class NoNextSteps extends Error {}

export default NoNextSteps;
